import React from 'react';
import { useField, FieldAttributes } from 'formik';
import { Text, Radio } from '@tonic-ui/react';
import { InlineError } from './index';

type RadioButtonProps = {
  label: string;
  name: string;
  variantColor?: string;
  size?: string;
  disabled?: boolean;
} & FieldAttributes<Record<string, unknown>>;

const RadioButton = ({
  label,
  variantColor,
  size = 'sm',
  disabled,
  ...rest
}: RadioButtonProps): JSX.Element => {
  const [field, meta] = useField(rest);
  const isInvalid = meta.error && meta.touched ? meta.error : '';
  return (
    <>
      <Radio {...field} size="md">
        {label}
      </Radio>
      {isInvalid && (
        <Text size="xs" mt="1x">
          <InlineError errorName={isInvalid} />
        </Text>
      )}
    </>
  );
};

export default RadioButton;
